import React from 'react'
import { money } from '../financial/formatting'
import ChannelCard from './ChannelCard'
import ChannelFunnel from './ChannelFunnel'
import EmptyChannel from './EmptyChannel'
import MiniKpi from './MiniKpi'
import { fmtPct } from './model'

// Leads the partner posts to us. The funnel starts at Accepted, not at
// Submitted: intake rejections can't be told apart by campaign, so they live
// in their own company-wide row (IntakeRejections) instead of here.
export default function ApiChannelCard({ block, live, earningsLabel }) {
  const empty = Number(block.accepted || 0) === 0

  return (
    <ChannelCard id="pw-api" channel="api" title="Leads you send by API" block={block} earningsLabel={earningsLabel}>
      {empty ? (
        <EmptyChannel>
          {live
            ? 'Your API key is live — send your first batch to see results here.'
            : "Your API key isn't live yet — your account manager will switch it on once your test leads look right."}
        </EmptyChannel>
      ) : (
        <>
          <ChannelFunnel
            label="API funnel"
            color="var(--channel-api)"
            steps={[
              { label: 'Accepted', value: block.accepted },
              { label: 'Sold', value: block.sold },
              { label: 'Redirected', value: block.redirected },
            ]}
          />
          <div className="pw-minikpis">
            <MiniKpi label="Avg per sold lead" value={money(block.avg_per_sold)} />
            <MiniKpi label="Redirect rate" value={fmtPct(block.redirect_rate_pct)} hint="Sold leads whose customer we sent on to the buyer's offer." />
            <MiniKpi label="Sale rate" value={fmtPct(block.sale_rate_pct)} hint="Sold leads out of the leads we accepted." />
          </div>
        </>
      )}
    </ChannelCard>
  )
}
